<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-spacer />
              <v-col
                cols="10"
                class="pb-0"
              >
                <v-img
                  :src="convertedPhoto(photo, type)"
                  height="100%"
                  width="100%"
                />
              </v-col>
              <v-spacer />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  components: {},
  data: () => ({
    // Form
    dialog: false,
    photo: '',
    type: '',
    name: '',
    title: '',
  }),
  watch: {},
  methods: {
    openDialog(photo, type, title = null) {
      this.dialog = true;
      if (photo) { this.photo = photo; }
      if (type) { this.type = type; }
      if (title) { this.title = title; }
    },
    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      if (this.fromFile) return this.photo;
      return `data:${mimeType};base64, ${photo}`;
    },
  },
};
</script>

  <style scoped>
  .mrp-btn-add {
    min-width: 35px !important;
    padding: 0 !important;
  }
  </style>
